module.exports = __webpack_public_path__ + "img/lili2.60411dae.png";